export default{
    name:'Sotaプログラミングルーム',
    version:"1.0.02",
    release:"2021-11-2"
}